import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { Navigate, Link } from 'react-router-dom';
import { LogIn, AlertCircle } from 'lucide-react';
import '../styles/client.css';

function Login() {
  const { login, isAuthenticated, isLoading, error } = useAuth();
  const [isSigningIn, setIsSigningIn] = useState(false);

  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  }

  const handleLogin = async () => {
    setIsSigningIn(true);
    await login();
    setIsSigningIn(false);
  };

  return (
    <div className="login-page">
      <div className="login-panel">
        <div className="brand-mark">R</div>
        <h1>RGNR Capital Partners</h1>
        <p className="sub">Client portal</p>

        <p className="desc">
          Sign in with your authorized Google account to access your portfolio,
          performance history, and investor letters.
        </p>

        {error && (
          <div className="login-error">
            <AlertCircle size={18} />
            <span>{error}</span>
          </div>
        )}

        <button
          className="login-google-btn"
          onClick={handleLogin}
          disabled={isSigningIn || isLoading}
        >
          <LogIn size={18} />
          {isSigningIn ? 'Signing in...' : 'Sign in with Google'}
        </button>

        <p className="login-note">Access is restricted to authorized investors only.</p>
        <Link to="/" className="login-back">&larr; Back to home</Link>
      </div>
    </div>
  );
}

export default Login;
